import { createSelector } from 'reselect'

import { RecursionRule } from 'types';

const sort = (source: RecursionRule[]) => source
    .sort((r1, r2) => {
        // if (r1.is_list) {
        //     return 1;
        // }

        // if (r2.is_list) {
        //     return -1;
        // }

        // let r1Value = r1.start ? new Date(r1.start).getTime() : Number.POSITIVE_INFINITY;
        // let r2Value = r2.start ? new Date(r2.start).getTime() : Number.POSITIVE_INFINITY;

        // if (completedAtBottom) {
        //     if (new Date(r1.end) < new Date()) {
        //         // Completed
        //         r1Value = new Date(r1.end).getTime() + 10000000000000;
        //     }

        //     if (new Date(r2.end) < new Date()) {
        //         // Completed
        //         r2Value = new Date(r2.end).getTime() + 10000000000000;
        //     }
        // }

        // if (r1Value > r2Value) return 1;
        // if (r1Value < r2Value) return -1;

        // if (new Date(r1.created_at).getTime() > new Date(r2.created_at).getTime()) return 1;
        // if (new Date(r1.created_at).getTime() < new Date(r2.created_at).getTime()) return -1;

        // const r1Name = (r1.name && r1.name.toLowerCase());
        // const r2Name = (r2.name && r2.name.toLowerCase());

        // if (r1Name > r2Name) return 1;
        // if (r1Name < r2Name) return -1;

        if (r1.id > r2.id) return 1;
        if (r1.id < r2.id) return -1;

        return 0;
    });

const getRecursionRule = (rules: RecursionRule[], ruleId: string) => rules.find(rule => rule.id === ruleId);
export const makeGetRecursionRule = () => createSelector(getRecursionRule, rules => rules);

const getSortedActiveProjectResourceRepeatRules = (resourceRepeatRules: RecursionRule[], projectId: string) => sort(resourceRepeatRules
    .filter(rule => rule.project === projectId));
export const makeGetSortedActiveProjectResourceRepeatRules = () => createSelector(getSortedActiveProjectResourceRepeatRules, resourceRepeatRules => resourceRepeatRules);
